import React from "react";
import './Hint.css';
const Hint = (props) => {
    return (
        <span className="Hint" onClick={props.hintOnClick} onMouseEnter={props.setHintShow} onMouseLeave={props.setHintHidden}>
            <span>?</span>
            <div
                className={`Hint__content ${props.hintState ? "Hint__content_active" : ""}`}>
                {props.hint}
            </div>

        </span>

    )
}

export const AutoHint = (props) => {
    const [hintState, setHintState] = React.useState(false);
    return (
        <span className="Hint" onMouseEnter={() => setHintState(true)} onMouseLeave={() => setHintState(false)}>
            <span>?</span>
            <div
                className={`Hint__content ${hintState ? "Hint__content_active" : ""}`}>
                {props.hint}
            </div>

        </span>

    )
}

export default Hint;